import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

function Vi(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="createnewfile">
                1.&nbsp;<span className="material-symbols-outlined">note_add</span>&nbsp;{translate('createnewfile')}
            </Typography>
            <p><strong>{translate('createnewfile')}</strong> là một hành động dùng để tạo ra 1 tệp excel. Tệp được tạo ra mặc định có 1 trang tính tên là <strong>Sheet</strong>.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này.</td>
                                <td>$newFileExcel_1</td>
                            </tr>
                            <tr>
                                <td>{translate('directory')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là đường dẫn thư mục lưu tệp. Nhập <strong>/tmp</strong> để chỉ định thư mục gốc.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('filename')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là tên của tệp Excel.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$newFileExcel_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('directory')}</span>
                            <div>/tmp/directory-name/</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filename')}</span>
                            <div>file-name.xlsx</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>/tmp/directory-name/file-name.xlsx</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="getsheetnames">
                2.&nbsp;<span className="material-symbols-outlined">format_list_bulleted</span>&nbsp;{translate('getsheetnames')}
            </Typography>
            <p><strong>{translate('getsheetnames')}</strong> là một hành động lấy tất các tên của trang tính trong tệp Excel dưới dạng mảng.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này.</td>
                                <td>$sheetNames_1</td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là đường dẫn của tệp Excel.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$sheetNames_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/directory-name/file-name.xlsx</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            "sheet"
                                        ], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="changesheetname">
                3.&nbsp;<span className="material-symbols-outlined">published_with_changes</span>&nbsp;{translate('changesheetname')}
            </Typography>
            <p><strong>{translate('changesheetname')}</strong> là một hành động thay đổi tên của 1 trang tính trong tệp Excel.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là đường dẫn của tệp Excel.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('sheetname')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là tên gốc của trang tính muốn thay đổi.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('newsheetname')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là tên mới của trang tính.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/directory-name/file-name.xlsx</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('sheetname')}</span>
                            <div>sheet</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('newsheetname')}</span>
                            <div>new sheet</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="selectsheet">
                4.&nbsp;<span className="material-symbols-outlined">grid_on</span>&nbsp;{translate('selectsheet')}
            </Typography>
            <p><strong>{translate('selectsheet')}</strong> là một hành động để chọn một trang tính. Để thực hiện thao tác trên Excel trước tiên bạn cần phải chọn trang tính cần thao tác.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này.</td>
                                <td>$workSheet_1</td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là đường dẫn của tệp Excel.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('sheetname')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là tên của trang tính.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="object" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$workSheet_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/directory-name/file-name.xlsx</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('sheetname')}</span>
                            <div>Sheet</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        {
                                            "filePath": "/tmp/directory-name/file-name.xlsx",
                                            "sheetName": "Sheet"
                                        }, null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="readcell">
                5.&nbsp;<span className="material-symbols-outlined">font_download</span>&nbsp;{translate('readcell')}
            </Typography>
            <p><strong>{translate('readcell')}</strong> là hành động đọc giá trị của một ô trong trang tính.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này.</td>
                                <td>$cellValue_1</td>
                            </tr>
                            <tr>
                                <td>{translate('worksheet')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="object" />
                                </td>
                                <td>Là trang tính đích.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('celllabel')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nhãn ô cần đọc.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$cellValue_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('worksheet')}</span>
                            <div>$workSheet_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('celllabel')}</span>
                            <div>A1</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>123</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="writecell">
                6.&nbsp;<span className="material-symbols-outlined">edit_square</span>&nbsp;{translate('writecell')}
            </Typography>
            <p><strong>{translate('writecell')}</strong> là một hành động ghi một giá trị vào một ô trong trang tính.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('worksheet')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="object" />
                                </td>
                                <td>Là trang tính đích.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('celllabel')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nhãn ô cần ghi.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('value')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là giá trị ghi vào.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                    <div className='parameter'>
                            <span className='parameter-name'>{translate('worksheet')}</span>
                            <div>$workSheet_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('celllabel')}</span>
                            <div>A1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('value')}</span>
                            <div>456</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('newsheetname')}</span>
                            <div>456</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="readrange">
                7.&nbsp;<span className="material-symbols-outlined">type_specimen</span>&nbsp;{translate('readrange')}
            </Typography>
            <p><strong>{translate('readrange')}</strong> là hành động đọc các giá trị trong phạm vi xác định của trang tính thành mảng hai chiều.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này.</td>
                                <td>$rangeValue_1</td>
                            </tr>
                            <tr>
                                <td>{translate('worksheet')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="object" />
                                </td>
                                <td>Là trang tính đích.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('range')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nhãn ô cần đọc.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$rangeValue_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('worksheet')}</span>
                            <div>$workSheet_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('range')}</span>
                            <div>A1:B2</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            [
                                                123,
                                                null
                                            ],
                                            [
                                                456,
                                                null
                                            ]
                                        ], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="writerange">
                8.&nbsp;<span className="material-symbols-outlined">app_registration</span>&nbsp;{translate('writerange')}
            </Typography>
            <p><strong>{translate('writerange')}</strong> là một hành động ghi một mảng vào một trang tính.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('worksheet')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="object" />
                                </td>
                                <td>Là trang tính đích.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('celllabel')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nhãn ô cần ghi.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('value')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="array" />
                                </td>
                                <td>Là giá trị ghi vào.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                    <div className='parameter'>
                            <span className='parameter-name'>{translate('worksheet')}</span>
                            <div>$workSheet_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('celllabel')}</span>
                            <div>A1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('value')}</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            [
                                                123,
                                                "abc"
                                            ],
                                            [
                                                456,
                                                "def"
                                            ]
                                        ], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="deleterange">
                9.&nbsp;<span className="material-symbols-outlined">backspace</span>&nbsp;{translate('deleterange')}
            </Typography>
            <p><strong>{translate('deleterange')}</strong> là hành động xoá các giá trị trong phạm vi xác định của trang tính.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('worksheet')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="object" />
                                </td>
                                <td>Là trang tính đích.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('range')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nhãn ô cần ghi.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                    <div className='parameter'>
                            <span className='parameter-name'>{translate('worksheet')}</span>
                            <div>$workSheet_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('range')}</span>
                            <div>A1:B2</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="convertexceltocsv">
                10.&nbsp;<span className="material-symbols-outlined">restore_page</span>&nbsp;{translate('convertexceltocsv')}
            </Typography>
            <p><strong>{translate('convertexceltocsv')}</strong> là hành động chuyển đổi trang tính của têp Excel thành 1 tệp CSV mới.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này.</td>
                                <td>$excelToCSV_1</td>
                            </tr>
                            <tr>
                                <td>{translate('worksheet')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="object" />
                                </td>
                                <td>Là trang tính đích.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('filename')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là tên mới của tệp CSV.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                    <div className='parameter'>
                            <span className='parameter-name'>{translate('worksheet')}</span>
                            <div>$workSheet_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filename')}</span>
                            <div>Sheet</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>/tmp/directory-name/Sheet.csv</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="writecsv">
                11.&nbsp;<span className="material-symbols-outlined">text_snippet</span>&nbsp;{translate('writecsv')}
            </Typography>
            <p><strong>{translate('writecsv')}</strong> là hành động tạo 1 tệp CSV mới.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này.</td>
                                <td>$newFileCSV_1</td>
                            </tr>
                            <tr>
                                <td>{translate('filename')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là tên của tệp CSV.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('value')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="array" />
                                </td>
                                <td>Là giá trị ghi vào tệp CSV. (giá trị ở dạng mảng 2 chiều)</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                    <div className='parameter'>
                            <span className='parameter-name'>{translate('worksheet')}</span>
                            <div>$newFileCSV_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filename')}</span>
                            <div>Sample</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('value')}</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            [
                                                "No",
                                                "01",
                                                "02"
                                            ],
                                            [
                                                "Product",
                                                "Pen",
                                                "Note"
                                            ]
                                        ], null, 2)}
                                </pre>
                            </div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>/tmp/directory-name/Sample.csv</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="readcsv">
                12.&nbsp;<span className="material-symbols-outlined">document_scanner</span>&nbsp;{translate('readcsv')}
            </Typography>
            <p><strong>{translate('readcsv')}</strong> là hành động đọc tệp CSV dưới dạng một mảng.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này.</td>
                                <td>$readCSV_1</td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là đường dẫn của tệp CSV.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('encoding')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Chỉ định mã hóa ký tự của tệp nén. Nếu tên tệp sau khi mở rộng chứa các ký tự tiếng Nhật, các ký tự có thể bị cắt xén. Bạn có thể ngăn các ký tự bị cắt xén bằng cách chỉ định mã ký tự.</td>
                                <td>UTF-8</td>
                            </tr>
                            <tr>
                                <td>{translate('headers')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hàng tiêu đề, nếu công tắc <strong>{translate('header')}</strong> được bật (true) thì kết quả bao gồm luôn dòng đầu tiên.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$readCSV_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/directory-name/Sample.csv</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('headers')}</span>
                            <div>true</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            [
                                                "No",
                                                "01",
                                                "02"
                                            ],
                                            [
                                                "Product",
                                                "Pen",
                                                "Note"
                                            ]
                                        ], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="changedelimitercsvfile">
                13.&nbsp;<span className="material-symbols-outlined">published_with_changes</span>&nbsp;{translate('changedelimitercsvfile')}
            </Typography>
            <p><strong>{translate('changedelimitercsvfile')}</strong> là hành động thay đổi ký tự phân tách các cột trong tệp CSV.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này.</td>
                                <td>$changeDelimiterCsvFile</td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là đường dẫn của tệp CSV.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('from')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là một ký tự phân tách hiện tại.</td>
                                <td>;</td>
                            </tr>
                            <tr>
                                <td>{translate('to')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là một ký tự phân tách bạn muốn thay thế.</td>
                                <td>,</td>
                            </tr>
                            <tr>
                                <td>{translate('encoding')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Chỉ định mã hóa ký tự của tệp nén. Nếu tên tệp sau khi mở rộng chứa các ký tự tiếng Nhật, các ký tự có thể bị cắt xén. Bạn có thể ngăn các ký tự bị cắt xén bằng cách chỉ định mã ký tự.</td>
                                <td>UTF-8</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$csvFile_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/directory-name/Sample.csv</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('from')}</span>
                            <div>;</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('to')}</span>
                            <div>,</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>/tmp/directory-name/Sample.csv</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="appendvaluetocsvfile">
                14.&nbsp;<span className="material-symbols-outlined">post_add</span>&nbsp;{translate('appendvaluetocsvfile')}
            </Typography>
            <p><strong>{translate('appendvaluetocsvfile')}</strong> là hành động nối hàng vào tệp CSV.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này.</td>
                                <td>$csvFile_1</td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là đường dẫn của tệp CSV.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('value')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="array" />
                                </td>
                                <td>Là giá trị ghi vào tệp CSV. (giá trị ở dạng mảng 2 chiều)</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('position')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là vị trí hàng để nối thêm. Chỉ định giá trị <strong>0</strong> để thêm vào đầu tệp <strong>end</strong> để thêm vào cuối tệp.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('delimiter')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là một ký tự dùng để phân cách các cột.</td>
                                <td>,</td>
                            </tr>
                            <tr>
                                <td>{translate('encoding')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Chỉ định mã hóa ký tự của tệp nén. Nếu tên tệp sau khi mở rộng chứa các ký tự tiếng Nhật, các ký tự có thể bị cắt xén. Bạn có thể ngăn các ký tự bị cắt xén bằng cách chỉ định mã ký tự.</td>
                                <td>UTF-8</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$csvFile_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/directory-name/Sample.csv</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('value')}</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            [
                                                "03",
                                                "04"
                                            ],
                                            [
                                                "Ruler",
                                                "Eraser"
                                            ]
                                        ], null, 2)}
                                </pre>
                            </div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('position')}</span>
                            <div>end</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('delimiter')}</span>
                            <div>,</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>/tmp/directory-name/Sample.csv</div>
                        </div>
                    </div>
                </li>
            </ul>
        </Box>
    );
}
export default withTranslate(Vi);